import React from "react"
import TitleStyled from "./styles/titleStyles"
import ServicesStyled from "./styles/servicesStyles"
import myInitObject from "../ultis/variable"
import uuid from "react-uuid"

const Services = ({ heading, icon, iconPosition, service }) => {
  return (
    <ServicesStyled icon={icon} iconPosition={iconPosition}>
      <div className="container">
        <TitleStyled textAlign="center" linePosition="center" color="#000">
          <h2 dangerouslySetInnerHTML={{ __html: heading }}></h2>
        </TitleStyled>
        <div className="services__wrapper">
          <div className="services__icon"></div>
          {service.map(item => (
            <div className="services__item" key={uuid()}>
              <div className="services__item__icon">
                <img
                  src={myInitObject.cockpitUrl + item.value.img.path}
                  alt={item.value.heading}
                />
              </div>
              <p
                className="services__item__heading"
                style={{ color: item.value.headingColor }}
                dangerouslySetInnerHTML={{ __html: item.value.heading }}
              ></p>
              <div
                className="services__item__description"
                dangerouslySetInnerHTML={{ __html: item.value.description }}
              ></div>
            </div>
          ))}
        </div>
      </div>
    </ServicesStyled>
  )
}

export default Services
